/**
 * Display-only terminology. The product shows "Organization" where the code, API and
 * database say "Tenant", and "Workspace" where they say "SaaS". Names that arrive from the
 * API (menu features, module names — stored in MFeature rows) are passed through here so
 * the UI reads consistently without changing any stored value, route, role or contract.
 *
 * Use it on LABELS only — never on keys, routes, role names or anything sent to the API.
 */
const TERMS: Record<string, string> = {
  Tenants: 'Organizations', Tenant: 'Organization',
  tenants: 'organizations', tenant: 'organization',
  SaaS: 'Workspace', Saas: 'Workspace',
};

export function displayTerm(label: string | null | undefined): string {
  if (!label) return label ?? '';
  return label
    .replace(/\b(Tenants?|tenants?|SaaS|Saas)\b/g, m => TERMS[m] ?? m)
    .replace(/(?<![\w'-])([Aa]) (?=[Oo]rganization)/g, '$1n ');
}
